import React, { useState, useEffect, useCallback } from 'react';
import { useSnackbar } from 'notistack';
import * as staticsApi from '../../lib/api/statics';
import SalesStaticsTeamTable from '../../components/salesresults_statics/SalesStaticsTeamTable';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const SalesresultsStaticsTeamContainer = ({
  selectedYear,
  strMonth,
  strDay, // 추가된 Props
  endMonth,
  endDay,   // 추가된 Props
  tableRef,
  searchData,
  selectPrjTyp,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]); // 초기값을 빈 배열로 설정

  // API 호출 로직을 useCallback으로 감싸 일관성 유지
  const onLoadData = useCallback(async () => {
    setLoading(true);

    // API 전송용 파라미터 구성 (일자 정보 포함)
    const apiParams = {
      // 서버 요구 형식에 따라 'YYYY-MM-DD'로 보낼지 확인 필요
      startDt: `${selectedYear}-${strMonth}-${strDay}`,
      endDt: `${selectedYear}-${endMonth}-${endDay}`,
      target: 'team'
    };

    try {
      const res = await staticsApi.getSalesStaticsByNew(
        selectPrjTyp,
        apiParams, // 변수명 중복 방지를 위해 apiParams로 변경
      );
      
      if (res.data && res.data.list) {
        setData(res.data.list);
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message;
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  }, [selectedYear, strMonth, strDay, endMonth, endDay, selectPrjTyp, enqueueSnackbar]);

  // 부모에서 생성한 유니크 키(searchData)가 변경될 때만 실행
  useEffect(() => {
    if (searchData) {
      onLoadData();
    }
  }, [searchData, onLoadData]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <SalesStaticsTeamTable
      data={data}
      loading={loading}
      tableRef={tableRef}
      selectPrjTyp={selectPrjTyp}
      strMonth={strMonth}
      endMonth={endMonth}
    />
  );
};

export default SalesresultsStaticsTeamContainer;
